import React from 'react'
import styled from 'styled-components'
import { Checkbox, Divider, Radio, Row } from 'antd'
import {
  StyledIconExcalmationMark,
  StyledQuestionTypeChangeInfo,
  StyledStrongText,
} from './styled'

const Group = Radio.Group

const ACTIONS = {
  SKIP: 'SKIP',
  SCORE: 'SCORE',
  MANUAL: 'MANUAL',
  DISCARD: 'DISCARD',
}

const AddedItems = ({ onUpdateSettings, settings, showLabel, showEdit }) => {
  return (
    <InputsWrapper data-cy="added-items">
      <Row>
        {showLabel && (
          <OptionTitle>Added Items or changed item types:</OptionTitle>
        )}
        <Question>
          You have added new items or changed item’s type. How would you like to
          update scores for previously submitted attempts?
        </Question>
      </Row>
      <Group
        value={settings.addedQuestion}
        onChange={(e) => onUpdateSettings('addedQuestion', e.target.value)}
      >
        <Row key="addedQuestion">
          {!showEdit && (
            <Question margin="1rem 0px 0px 0px">
              For all new/changed items :
            </Question>
          )}
          <StyledRadio data-cy="no-points" value={ACTIONS.SKIP}>
            GIVE ZERO POINTS{' '}
            {!showEdit && (
              <OptionDescription>
                {' '}
                - Students receive zero for this item.
              </OptionDescription>
            )}
          </StyledRadio>
          <StyledRadio data-cy="full-points" value={ACTIONS.SCORE}>
            GIVE FULL POINTS{' '}
            {!showEdit && (
              <OptionDescription>
                {' '}
                - Students automatically receive full credit.
              </OptionDescription>
            )}
          </StyledRadio>
          <StyledRadio data-cy="manual-points" value={ACTIONS.MANUAL}>
            MANUALLY GRADE{' '}
            {!showEdit && (
              <OptionDescription>
                {' '}
                - You will review and assign scores.
              </OptionDescription>
            )}
          </StyledRadio>
        </Row>
      </Group>
      {!showEdit && (
        <Divider
          style={{
            width: '585px',
            marginLeft: '-25px',
          }}
        />
      )}
      <StyledQuestionTypeChangeInfo fontSize={showEdit ? '12px' : '14px'}>
        <StyledIconExcalmationMark backgroundColor="#8A6700" />
        <div>
          <StyledStrongText>Please note :</StyledStrongText> If you change the
          item type, all existing student responses for that item will be
          permanently deleted, and the item will not be rescored. Other edited
          items will be rescored based on your selection above.
        </div>
      </StyledQuestionTypeChangeInfo>
      {showEdit && (
        <>
          <div
            style={{
              fontSize: '12px',
              paddingLeft: '1.5rem',
              marginTop: '1.5rem',
            }}
          >
            Edited items will be regraded according to your choice in Edited
            items.
          </div>
          <Divider
            style={{
              width: '585px',
              marginLeft: '-25px',
            }}
          />
        </>
      )}
    </InputsWrapper>
  )
}

const EditedItems = ({
  onUpdateSettings,
  settings,
  showLabel,
  showEditRubric,
}) => {
  return (
    <InputsWrapper data-cy="edited-items">
      <Row>
        {showLabel && <OptionTitle>Edited Items</OptionTitle>}
        <Question>
          The change made previously submitted responses to be regraded. How
          would you like to proceed?
        </Question>
      </Row>
      <Group
        defaultValue={settings.editedQuestion}
        onChange={(e) => onUpdateSettings('editedQuestion', e.target.value)}
      >
        <Row key="editedQuestion">
          <StyledRadio data-cy="skip-grading" value={ACTIONS.SKIP}>
            SKIP RESCORING
          </StyledRadio>
          <StyledRadio data-cy="restore-grading" value={ACTIONS.SCORE}>
            RESCORE AUTOMATICALLY
          </StyledRadio>
          <StyledRadio data-cy="manual-grading" value={ACTIONS.MANUAL}>
            MARK FOR MANUAL GRADING
          </StyledRadio>
        </Row>
      </Group>
      {showEditRubric && (
        <Checkbox
          style={{ marginTop: '2rem' }}
          defaultChecked
          onChange={(e) =>
            onUpdateSettings('excludeRubricItemsFromRegrade', e.target.checked)
          }
          data-cy="excludeRubricItemScoreFromRegrade"
        >
          Exclude rubric item scores from regrading after editing.
        </Checkbox>
      )}
    </InputsWrapper>
  )
}

export default {
  AddedItems,
  EditedItems,
}

const InputsWrapper = styled.div`
  margin-top: ${({ mt }) => mt || '20px'};
  .ant-radio-wrapper {
    display: block;
  }
`

const Question = styled.p`
  font-weight: 400 !important;
  font-size: 14px;
  margin: ${({ margin }) => margin || 'auto'};
`

const OptionTitle = styled.h3`
  font-weight: 700;
  font-size: 14px;
  color: #434b5d;
`

const StyledRadio = styled(Radio)`
  margin-top: 20px;
  font-size: 14px;
  font-weight: 700;
  span {
    color: #434b5d;
    letter-spacing: 0.19px;
  }
`

const OptionDescription = styled.p`
  display: inline;
  font-weight: 400;
`
